import { SET_NEARBY_PROPERTY_WIDGET_LISTING, WIDGET_SLIDE_TO, FETCHING_WIDGET_DATA } from '../actions/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_NEARBY_PROPERTY_WIDGET_LISTING:
      return {
        ...state,
        nearbyPropertyWidgetResponse: action.data,
        currentIndex: action.initSlideIndex,
        fetching: false,
      };
    case WIDGET_SLIDE_TO:
      return {
        ...state,
        currentIndex: action.index,
      };
    case FETCHING_WIDGET_DATA:
      return {
        ...state,
        fetching: action.fetching,
      };
    default:
      return state;
  }
};
